<template>
    <div class="w100 bgWhite">
        <article class="wContent center" style="padding-top: 20px">
            <!-- 顶部 start -->
            <el-row>
                <el-col :span="17">
                    <div class="quote-d-enterinfo">
                        <span class="recommend-status" v-show="enterpriseInfo.recommendStatus"></span>
                        <img :src="enterpriseInfo.logoPath || defaultLogo" alt="" class="logo">
                        <span class="inlineBlock font16 fontBold">{{ enterpriseInfo.name }}</span>
                        <!-- <small class="fontRed inlineBlock vTop textCenter" v-show="enterpriseInfo.benchmarkStatus">基</small> -->
                    </div>
                </el-col>
                <el-col :span="7">
                    <div>
                        <div class="quote-key-input block w100">
                            <el-input placeholder="请输入内容" v-model="searchKey">
                                <template slot="append">
                                    <a href="javascript:;" class="fontWhite" @click="findByPhone(1)">搜索</a>
                                </template>
                            </el-input>
                        </div>
                        <div class="textRight quote-d-code-text">
                            <a href="javascript:;" @click="wxCodeDialog = true" class="font14 fontLighter"><i class="el-icon-connection font16"></i>扫码查看手机报价信息</a>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 顶部 end -->

            <div class="quote-d-line w100"></div>
            
            <el-row :gutter="20">
                <el-col :span="17">

                    <div v-show="!none">
                        <el-row :gutter="20">
                            <el-col :span="8" v-for="(item, index) in tableList" :key="index">
                                <div class="trade-d-list-box" :style="{height: id == userPhone ? '260px' : '211px'}">
                                    <div class="trade-product-btn" style="height: 38px;">
                                        <span v-for="(cItem, cIndex) in item.enterpriseInfo.varieties" :key="cIndex" ><el-button size="mini" v-if="cIndex < 2">{{ cItem.name }}</el-button></span>
                                        <span class="font14 fontLight floatRight" style="margin-top: 2px;">{{ item.createTime.substr(0, 10) }}</span>
                                    </div>
                                    <div class="bgGrey info fontNormal font14">
                                        <p>{{ item.content }}</p>
                                    </div>
                                    <div class="status bgGrey" :style="{height: id == userPhone ? '28px' : '0', padding: id == userPhone ? '10px' : '0', 'overflow-y': 'hidden'}">
                                        <el-button type="danger" size="small" v-if="item.status == 0" @click="showEditDialog(item)"><i class="el-icon-edit"></i>待审核</el-button>
                                        <el-button type="danger" size="small" v-if="item.status == -1" @click="showEditDialog(item)"><i class="el-icon-edit"></i>审核未通过</el-button>
                                        <el-button type="default" size="small" v-if="item.status == -2">无效</el-button>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 分页 start -->
                    <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;" v-show="!none">
                        <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
                    </div>
                    <!-- 分页 end -->

                    <div class="textCenter font16 fontNormal" style="padding-top: 20px;" v-show="none">暂无商情信息~</div>
                </el-col>
                <el-col :span="7">
                    <div class="quote-d-right-info">
                        <span class="inlineBlock title font14 fontLight vTop  ">主营产品</span>
                        <div class="inlineBlock info-right" v-if="enterpriseInfo.varieties">
                            <el-button type="danger" size="small" v-for="(item, index) in enterpriseInfo.varieties" :key="index">{{ item.name }}</el-button>
                            <!-- <el-button type="danger" size="small">方矩管</el-button> -->
                            <!-- <el-button type="danger" size="small">方矩管</el-button> -->
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">联系人</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.contacts }}</div>
                        </div>
                        <div>
                            <span class="inlineBlock title font14 fontLight vTop ">联系电话</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.phone }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">商家信息</span>
                            <div class="inlineBlock info-right info-right-text fontDark fontBold font14">{{ enterpriseInfo.name }}</div>
                        </div>
                        <div>
                            <span class="inlineBlock title font14 fontLight vTop ">所在地区</span>
                            <div class="inlineBlock info-right info-right-text fontNormal font14">{{ enterpriseInfo.address }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="inlineBlock title font14 fontLight vTop">企业简介</span>
                            <div class="inlineBlock info-right info-right-text fontNormal font14">{{ enterpriseInfo.introduction }}</div>
                        </div>
                    </div>
                    <div class="quote-d-right-info">
                        <div style="margin-bottom: 20px;">
                            <span class="block title font14 fontLight vTop">手机报价</span>
                            <div class="code center">
                                <span class="trade-code-border"></span>
                                <img src="../../assets/images/footer_down.png" alt="" class="w100">
                            </div>
                            <span class="block mw-modular-box fontLight font14 textCenter">扫码下载app，查询手机报价</span>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <el-dialog
            title=""
            :visible.sync="wxCodeDialog"
            width="280px">
            <div class="textCenter" style="margin-top: -20px;">
                <img :src="qrcode" alt="" style="width: 240px; height: 240px;">
                <p>打开微信，点击底部的发现</p>
                <p>使用'扫一扫'即可查看</p>
            </div>
            </el-dialog>

            <!-- 编辑 start -->
            <el-dialog title="编辑" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogWithEdit" width="450px" style="padding: 10px 0;">
                <el-form ref="formEdit" :model="formEdit" label-width="120px" :rules="rulesEdit" size="small">
                    <el-form-item label="主营产品">
                        <el-tag v-for="(item, index) in formEdit.enterpriseInfo.varieties" :key="index" style="margin-right: 5px">{{ item.name }}</el-tag>
                    </el-form-item>
                    <el-form-item label="发布内容：">
                        <el-input v-model="formEdit.content" type="textarea" style="width: 240px;" placeholder="请输入"
                        maxlength="220"
                        show-word-limit
                        rows="10"></el-input>
                    </el-form-item>
                    <el-form-item class="submit">
                        <el-button size="small" type="danger" @click="onEditSubmit">保存</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <!-- 编辑 end -->
        </article>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import { baseUrl, getQueryString } from '../../assets/js/common'
export default {
    name: 'TradeDetail',
    components: {},
    data() {
        return {
            defaultLogo: require('../../assets/images/enter_default_logo.png'),
            qrcode: require('../../assets/images/footer_code.png'),
            userPhone: '', // 用于判断是否是自己的企业 自己企业能修改未审核内容
            id: '',
            searchKey: '',
            pageNo: 1,
            pageSize: 9,
            totalnum: 0,
            enterpriseInfo: {},
            tableList: [],
            none: false,
            wxCodeDialog: false,
            dialogWithEdit: false,
            formEdit: {
                enterpriseInfo: { varieties: '' },
                content: ''
            },
            rulesEdit: {
                content: [{required: true, message: '请输入内容', trigger: 'blur'}]
            }
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.getUserInfo();
        setTimeout(() => {
            this.findEnterByPhone();
            this.findByPhone();
        }, 300)
        // this.findByPhone();
    },
    methods: {
        /* 获取cookies */
        getUserInfo () {
            const self = this;
            const token = self.$cookies.get('token');
            if (token) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data != null) {
                                    self.userPhone = res.data.phone;
                                }
                            } 
                        }).catch(err => {
                        })
                    }
                })
            }
        },
        // 获取企业详细信息/api/enterprise/findByPhone/12345678
        findEnterByPhone () {
            const self = this;
            self.$get(`${baseUrl.business}/api/enterprise/findByPhone/${self.id}`, {}).then(res => {
                if (res.status == 200) {
                    self.enterpriseInfo = res.data ? res.data : {};
                } else {
                    self.$message.error(res.msg)
                    self.none = true;
                }
            })
        },

        // 根据手机号 获取商情列表
        findByPhone (type) {
            const self = this;
            if (type) {
                self.pageNo = 1;
                self.searchKey = self.searchKey.replace(/\s*/g,"");
            }
            self.$get(`${baseUrl.business}/api/businessInfo/findByPhone/${self.id}/${self.pageNo - 1}/${self.pageSize}?key=${self.searchKey}&status=${self.userPhone == self.id ? '' : 1}`, {}).then(res => {
                if (res.status == 200) {
                    if (res.data.content.length > 0) {
                        self.tableList = res.data.content;
                        self.totalnum = res.data.totalElements;
                        self.enterpriseInfo = res.data.content[0].enterpriseInfo;
                        self.none = false;
                    } else {
                        self.none = true;
                    }
                    // console.log(res.data);
                } else {
                    self.$message.error(res.msg);
                }
            })
        },

        // 切换分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.findByPhone();
        },

        // 编辑商情
        showEditDialog (item) {
            const self = this;
            self.formEdit = $.extend(true, {}, item);
            self.dialogWithEdit = true;
            // console.log(self.formEdit)
        },
        onEditSubmit () {
            const self = this;
            const param = {
                id: self.formEdit.id,
                content: self.formEdit.content,
                userId: self.formEdit.user.userId,
                enterpriseId: self.formEdit.enterpriseInfo.id
            }
            self.$put(`${baseUrl.business}/api/businessInfo/update`, param).then(res => {
                if (res.status == 200) {
                    self.$message('保存成功');
                    self.dialogWithEdit = false;
                    self.formEdit = {
                        enterpriseInfo: { varieties: '' },
                        content: ''
                    }
                    self.findByPhone()
                } else {
                    self.$message.error(res.msg);
                }
            }).catch((err) => {
                self.$message.error('保存失败，请重试！')
            })
        }
    }
    
}
</script>

<style scoped>
    .quote-d-enterinfo { position: relative; }
    .quote-d-enterinfo > .logo { height: 100px; margin-right: 10px; }
    .quote-d-enterinfo > span { vertical-align: top; padding-top: 10px; }
    .quote-d-enterinfo > .recommend-status { padding: 0; position: absolute; top: 0; left: 0; width: 40px; height: 40px; background: url('../../assets/images/trade_tuijian.png') no-repeat; background-size: 100% 100%; }
    .quote-d-enterinfo small { line-height: 18px; border: 1px solid #a30000; width: 18px; height: 18px; border-radius: 1px; font-size: 0.05rem; margin-top: 12px; margin-left: 5px;  }
    .quote-d-code-text { margin-top: 10px; }
    .quote-d-code-text i { padding-right: 5px; }
    .quote-d-line { border-top: 1px dashed #ccc; margin: 20px 0; }
    .quote-d-right-info { border: 1px solid #ccc; border-left: 5px solid #a30000; padding: 10px 10px; margin-bottom: 20px; }
    .quote-d-right-info  .title { width: 100px; }
    .quote-d-right-info .info-right { width: 209px; }
    .quote-d-right-info .info-right .el-button--danger,
    .quote-d-right-info .info-right .el-button--danger:hover,
    .status .el-button--danger,
    .status .el-button--danger:hover,
    .submit .el-button--danger,
    .submit .el-button--danger:hover { margin-left: 0; margin-right: 10px; margin-bottom: 10px; background: #a30000; border-color: #a30000; }
    .status .el-button--default,
    .status .el-button--default:hover { color: #333; cursor: default; border: 1px solid #aaa; }
    .info-right-text { line-height: 20px; }
    .quote-d-right-info .code { width: 100px; margin-top: 20px; position: relative; }
    .quote-d-right-info .code .trade-code-border { width: 130px; height: 130px; position: absolute; top: -16px; left: -16px; background: url('../../assets/images/quote_kuang.png') no-repeat; background-size: 100% 100%; }
    .trade-product-btn { padding: 0px 10px 5px 10px; }
    .trade-product-btn .el-button--mini,
    .trade-product-btn .el-button--mini:hover { 
        border-color: #a30000; 
        color: #a30000; 
        background: #fff; 
        margin-left: 0; 
        margin-right: 10px; 
        margin-bottom: 10px;
        line-height: 0.7;
        padding: 7px 10px;
    }
    .trade-d-list-box { border: 1px solid #909399; box-shadow: 3px 3px 2px #DCDFE6; border-radius: 5px; padding-top: 15px; margin-bottom: 20px; height: 260px; }
    .trade-d-list-box .info { 
        padding: 10px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;
        height: 148px;
        /* display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7; */
        overflow-y: auto;
    }
    .trade-d-list-box .info p { line-height: 22px; }
    .el-tag, .el-tag:hover { color: #a30000; background: #fff; border: 1px solid #a30000; }

</style> 